import React from "react";

function StepsSection() {
  const cardsData = [
    {
      title: "Search",
      description:
        "Quickly find relevant information and discover new currencies. All powered by Coinpaprika API.",
    },
    {
      title: "Bookmark",
      description:
        "Save your favorite coins to revisit them later. Never lose track of stats that matters to you.",
    },
    {
      title: "Enjoy",
      description:
        "Immerse yourself in a delightful experience. An enjoyable browsing journey.",
    },
  ];
  return (
    <div className="container mx-auto mt-12">
      <div>
        <div className="flex flex-col items-center justify-center p-4 text-center bg-white rounded-lg">
          <p className="mx-2 italic font-black text-transparent lowercase animate-text bg-gradient-to-r from-blue-500 via-cyan-500 to-violet-500 bg-clip-text">
            How it Works
          </p>
          <p className="mb-4 text-2xl font-bold text-gray-800">
            Using CoinWatch is simple
          </p>
        </div>

        <div className="items-center justify-center flex-none lg:flex">
          {cardsData.map((card, index) => (
            <div
              key={index}
              className="relative h-40 p-4 mx-2 mb-4 overflow-hidden bg-white border border-blue-500 shadow-xl"
            >
              <div className="absolute top-0 left-0 flex items-center justify-center w-6 h-6 m-2 text-white bg-blue-500 rounded-full">
                {index + 1}
              </div>
              <div className="flex items-center my-4">
                <div>
                  <h1 className="mb-1 text-xl font-bold">{card.title}</h1>
                  <p className="text-gray-600">{card.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default StepsSection;
